module.exports = __webpack_public_path__ + "img/talent_recruitment.0cfc3e1.png";